import * as types from '../actiontypes';
import {API_RESOURCES, createApiReadAction, createApiCreateAction, createApiDeleteAction} from '../../util/api';

export const createFlowChart = (engagementId, data) => {
	return createApiCreateAction(
		types.CREATE_FLOWCHART,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: null
		},
		data
	);
};

export const getFlowChart = (engagementId, queryString) => {
	return createApiReadAction(
		types.GET_FLOWCHART,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: null
		},
		queryString
	);
};

export const createNewStep = (engagementId, flowChartId, data) => {
	return createApiCreateAction(
		types.CREATE_FLOWCHART_NEW_STEP,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowChartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: null
		},
		data
	);
};

export const saveFlowChartConnection = (engagementId, flowChartId, flowchartStepId, data) => {
	return createApiCreateAction(
		types.SAVE_FLOWCHART_CONNECTION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: flowChartId,
			[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
			[API_RESOURCES.TARGETSTEPS]: null
		},
		data
	);
};

export function removeFlowChartConnection(engagementId, flowChartId, flowchartStepId, targetFlowchartStepId) {
	return createApiDeleteAction(types.DELETE_FLOWCHART_CONNECTION, {
		[API_RESOURCES.ENGAGEMENTS]: engagementId,
		[API_RESOURCES.FLOWCHART]: flowChartId,
		[API_RESOURCES.FLOWCHARTSTEPS]: flowchartStepId,
		[API_RESOURCES.TARGETSTEPS]: targetFlowchartStepId
	});
}

export const clearFlowChart = () => {
	return {
		type: types.CLEAR_FLOWCHART
	};
};


export const getFlowCharts = (engagementId, queryString) => {
	return createApiReadAction(
		types.GET_FLOWCHARTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.FLOWCHART]: null
		},
		queryString
	);
};

export function setIsFlowchartStepEditModalOpen(isFlowChartStepEditModelOpen) {
	return {
		type: types.SET_IS_FLOWCHART_STEP_EDIT_MODAL_OPEN,
		isFlowChartStepEditModelOpen
	};
}
